import { coerceRoleValue } from '../../config/audience';

function normalizedRole(role: string | null | undefined): string {
  const value = coerceRoleValue(role);
  return value === 'pd_carbon' ? 'project_developer' : value;
}

/** Where a signed-in account lands. Carbon project developers open their project list. */
export function homePathForRole(role: string | null | undefined): string {
  return normalizedRole(role) === 'project_developer' ? '/carbon-projects' : '/';
}

export function isProjectDeveloper(role: string | null | undefined): boolean {
  return normalizedRole(role) === 'project_developer';
}
